import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
  const locales = import.meta.glob('./locales/*.json', {
    eager: true,
    query: '?raw',
    import: 'default',
  })
  const messages = {}
  for (const [key, entry] of Object.entries(locales)) {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const localeKey = matched[1]
      messages[localeKey] = JSON.parse(entry)
    }
  }
  return messages
}

export default createI18n({
  locale: import.meta.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
})
